import React, { createContext, useState, useEffect, forwardRef } from 'react';
export const DialogHelper = /*#__PURE__*/createContext({
  height: undefined,
  width: undefined,
  left: undefined,
  right: undefined,
  top: undefined,
  bottom: undefined
});
/*!
 * Check if an element is out of the viewport
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}  elem The element to check
 * @return {Object}     A set of booleans for each side of the element
 */

const out = {};
export function isOutOfViewport(elem) {
  // Get element's bounding
  const bounding = elem.getBoundingClientRect(); // Check if it's out of the viewport on each side

  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
  out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;
  return out;
}
export function runOutsideCheck(refHTML) {
  if (refHTML) {
    const isOut = isOutOfViewport(refHTML === null || refHTML === void 0 ? void 0 : refHTML.current);

    if (isOut && isOut.top) {
      // Top is out of viewport
      return 'top';
    }

    if (isOut && isOut.left) {
      // Left side is out of viewoprt
      return 'left';
    }

    if (isOut && isOut.bottom) {
      // Bottom is out of viewport
      return 'bottom';
    }

    if (isOut && isOut.right) {
      // Right side is out of viewport
      return 'right';
    }

    return false;
  }

  return false;
}
export const DialogProvider = /*#__PURE__*/forwardRef(({
  func,
  children
}, ref) => {
  // todo const and not state
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  let top;
  let left;
  let right;
  const bottom = 0;
  useEffect(() => {
    if (ref) {
      const isOut = runOutsideCheck(ref);
      isOut && func(isOut);
    }
  }, [children]);
  return /*#__PURE__*/React.createElement(DialogHelper.Provider, {
    value: {
      height,
      width,
      left,
      top,
      right,
      bottom
    }
  }, children);
});